/**
 * Слот рабочего места: код / граф+таблица / дерево / сетка / код+черепаха.
 */
import { forwardRef } from 'react';
import UnifiedEditor from './UnifiedEditor';
import { WORKSPACE_KIND } from '../utils/workAttemptHelpers';
import CollaborativeYdocHost from './workspace/CollaborativeYdocHost';
import GraphTableWorkspace from './workspace/GraphTableWorkspace';
import SpreadsheetWorkspace from './workspace/SpreadsheetWorkspace';
import TurtleCanvas from './workspace/TurtleCanvas';

const UnifiedWorkspace = forwardRef(function UnifiedWorkspace({
  workspace,
  // collaborative session
  sessionId,
  taskId = null,
  onYdocReady,
  onStatusChange,
  onContentChange,
  onWorkspaceStateChange,
  seedWorkspaceState,
  // code editor
  theme,
  onThemeChange,
  onRunRequest,
  editorSettings,
  styleLintEnabled,
  onStyleLintChange,
  onFormattingChange,
}, ref) {
  const kind = workspace?.kind || WORKSPACE_KIND.CODE;
  const config = workspace?.config || {};
  const dataKey = `t${taskId ?? 'x'}:${kind}`;

  if (!workspace?.showWorkspace) return null;

  if (kind === WORKSPACE_KIND.GRAPH_TABLE || kind === WORKSPACE_KIND.TREE_TABLE) {
    return (
      <CollaborativeYdocHost
        sessionId={sessionId}
        onYdocReady={onYdocReady}
        onStatusChange={onStatusChange}
      >
        {({ ydoc }) => (
          <GraphTableWorkspace
            kind={kind}
            ydoc={ydoc}
            workspaceConfig={config}
            seedState={seedWorkspaceState}
            dataKey={dataKey}
            onStateChange={onWorkspaceStateChange}
          />
        )}
      </CollaborativeYdocHost>
    );
  }

  if (kind === WORKSPACE_KIND.SPREADSHEET) {
    return (
      <CollaborativeYdocHost
        sessionId={sessionId}
        onYdocReady={onYdocReady}
        onStatusChange={onStatusChange}
      >
        {({ ydoc }) => (
          <SpreadsheetWorkspace
            ydoc={ydoc}
            workspaceConfig={config}
            seedState={seedWorkspaceState}
            dataKey={dataKey}
            onStateChange={onWorkspaceStateChange}
          />
        )}
      </CollaborativeYdocHost>
    );
  }

  // code / code_turtle
  return (
    <div className={`unified-workspace-code ${kind === WORKSPACE_KIND.CODE_TURTLE ? 'with-turtle' : ''}`}>
      <div className="unified-workspace-code-main">
        <UnifiedEditor
          ref={ref}
          mode="collaborative"
          sessionId={sessionId}
          onContentChange={onContentChange}
          theme={theme}
          onThemeChange={onThemeChange}
          onYdocReady={onYdocReady}
          onRunRequest={onRunRequest}
          onStatusChange={onStatusChange}
          editorSettings={editorSettings}
          styleLintEnabled={styleLintEnabled}
          onStyleLintChange={onStyleLintChange}
          onFormattingChange={onFormattingChange}
        />
      </div>
      {kind === WORKSPACE_KIND.CODE_TURTLE ? (
        <div className="unified-workspace-turtle">
          <TurtleCanvas />
        </div>
      ) : null}
    </div>
  );
});

export default UnifiedWorkspace;
